<template lang="pug">
.report-detail
  forecast(:list="list" v-if="type=='1'")
  report(:list="list" v-if="type=='2'||type=='3'")
  publish(:list="list" v-if="type=='4'")
</template>

<script>
import Requests from '@utils/requests'
import Forecast from './partial/forecast'
import Report from './partial/report'
import Publish from './partial/publish'
export default {
  name: 'ReportDetail',
  components: {
    Forecast,
    Report,
    Publish
  },
  data() {
    return {
      id: '',
      type: '',
      list: []
    }
  },
  mounted() {
    this.$router.onReady(() => {
      this.fetchList(this.$route.params.id)
      this.type = this.$route.params.type
    })
  },
  methods: {
    fetchList(id) {
      return new Promise(resolve => {
        Requests({
          url: '/shudan/get_ht_calendar_detail_for_api',
          method: 'post',
          params: { sha1: id }
        }).then(({ data }) => {
          this.list = data.data
        })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.report-detail
  padding 1rem
</style>
